import { Link } from 'react-router-dom';

const experiences = [
  {
    icon: 'ri-ship-line',
    title: '海岛度假',
    description: '碧海蓝天、白沙椰林，在马尔代夫、巴厘岛、普吉岛享受阳光与海风的拥抱。',
    link: '/category/southeast-asia',
  },
  {
    icon: 'ri-landscape-line',
    title: '文化探索',
    description: '穿梭于京都古寺、吴哥遗迹与加德满都杜巴广场，触摸千年文明的脉搏。',
    link: '/category/east-asia',
  },
  {
    icon: 'ri-restaurant-line',
    title: '美食之旅',
    description: '从曼谷街头小吃到东京米其林，用味蕾丈量亚洲各地的风土人情。',
    link: '/category/east-asia',
  },
  {
    icon: 'ri-walk-line',
    title: '户外探险',
    description: '尼泊尔喜马拉雅徒步、清迈丛林飞跃、巴厘岛冲浪，释放你的冒险精神。',
    link: '/category/south-asia',
  },
];

export default function ExperienceSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            旅行方式
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
            找到属于你的旅行节奏
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3 max-w-xl mx-auto">
            无论你是哪种旅行者，亚洲天堂总有一种方式让你心动
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {experiences.map((exp) => (
            <Link
              key={exp.title}
              to={exp.link}
              className="group block cursor-pointer"
            >
              <div className="bg-background-100 rounded-lg p-6 md:p-7 border border-background-200/60 hover:border-primary-200 transition-all duration-300 text-center h-full">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className={`${exp.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mt-5 mb-2">
                  {exp.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                  {exp.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium mt-4 group-hover:gap-2 transition-all">
                  探索更多
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-14 md:mt-16 relative w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20breathtaking%20panoramic%20view%20of%20traditional%20Asian%20floating%20market%20with%20colorful%20wooden%20boats%20selling%20tropical%20fruits%20and%20flowers%2C%20lush%20green%20vegetation%20along%20canal%2C%20warm%20golden%20morning%20light%2C%20vibrant%20and%20lively%20cultural%20atmosphere%2C%20professional%20travel%20photography%20with%20rich%20colors%2C%20clean%20balanced%20horizontal%20composition&width=1600&height=600&seq=cta-banner-home&orientation=landscape"
            alt="亚洲天堂 - 开启您的梦想之旅"
            title="亚洲天堂 - 开启您的梦想之旅"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/40"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
            <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              准备好了吗？开启你的亚洲天堂之旅
            </h3>
            <p className="text-white/80 text-sm md:text-base mb-6 max-w-lg">
              从碧海白沙到千年古迹，亚洲天堂带你发现东方最动人的风景
            </p>
            <Link
              to="/category/southeast-asia"
              className="inline-flex items-center px-7 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即探索
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}